import { render, staticRenderFns } from "./DomainPoolBody.vue?vue&type=template&id=500a3cc6&scoped=true&"
import script from "./DomainPoolBody.vue?vue&type=script&lang=ts&"
export * from "./DomainPoolBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500a3cc6",
  null
  
)

export default component.exports